import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { LoginContext } from "./LoginContextProvider";
import useApi from "../Api/Api";
import Input from "../Components/Input";
import Button from "../Components/Button";
import storageManager from "../Utility/StorageManager";

const Login = () => {
  const [user, setUser] = useState({ email: "", password: "" });
  const [isFetching, setIsFetching] = useState(false);
  const [showError, setShowError] = useState(false);
  const { setLoginToken } = useContext(LoginContext);
  const { passwordIsReset } = useContext(LoginContext);
  const history = useHistory();
  const api = useApi();

  const handleSubmit = (event) => {
    setIsFetching(true);
    api
      .post("/sign_in", { user })
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        setLoginToken(`token=${data.authentication_token},email=${data.email}`);
        storageManager.setItem("email", data.email);
        history.push("/home");
      })
      .catch((error) => {
        setShowError(error);
      });
    event.preventDefault();
    setIsFetching(false);
  };

  const handleChange = ({ target: { name, value } }) => {
    setUser({ ...user, [name]: value });
  };

  return (
    <div className="flex justify-center h-full bg-white">
      <div className="w-1/2 flex justify-center items-center">
        <div className="flex flex-col items-stretch">
          <div className="text-center text-5xl">TM Login</div>
          <form id="submit" onSubmit={handleSubmit}>
            <div className="my-5">
              <Input
                type="email"
                label="Email"
                value={user.email}
                name="email"
                onChange={handleChange}
                disabled={isFetching}
                required
              />
            </div>
            <Input
              type="password"
              label="Password"
              value={user.password}
              name="password"
              onChange={handleChange}
              disabled={isFetching}
              required
            />
            <div className="py-4"></div>
            {showError && <div className="text-red-500 mt-4">Email and password do not match</div>}
            {passwordIsReset && <div className="text-green-500 mt-4">Your password has been reset</div>}
            <Button
              text={isFetching ? `Loading ${"\u00A0"}` : "Sign In"}
              type="submit"
              form="submit"
              value="Submit"
              disabled={isFetching}
              inProgress={isFetching}
              className="button button-lg"
            ></Button>
          </form>
          <Link to="/requestpassword" className="mt-5">
            Forgot Password?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
